import Vue from 'vue';
import App from './app.vue';

export const initModalStopIE = () => {
  const targetId = 'fc-main-modal';
  if (!document.getElementById(targetId)) return;

  const { env, assetPath } = document.getElementById(targetId).dataset;

  const initProps = {
    props: {
      env,
      assetPath,
    },
  };

  new Vue({
    render: (h) => h(App, initProps),
  }).$mount(`#${targetId}`);
};
